import { useEffect, useState } from "react";
import { Formik } from "formik";
import * as Yup from "yup";
import { Form, Button, Alert, Spinner } from "react-bootstrap";
import { _baseURL } from "../constants/api";

function CampingForm() {
    const [full, setFull] = useState(false);
    const [loading, setLoading] = useState(false);
    const [available, setAvailable] = useState(0);
    const [count, setCount] = useState(0);

    // Check seats availability
    useEffect(() => {
        fetch(_baseURL + "/camping/seats")
            .then((res) => res.json())
            .then((data) => {
                setFull(data.full);
                setAvailable(data.available);
                setCount(data.count);
            });
    }, []);

    const handlePayment = async (values) => {
        if (full) {
            alert("Seats are fully booked");
            return;
        }

        setLoading(true)
        // Create order
        const orderData = await fetch(_baseURL + "/camping/create-order", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(values),
        }).then(res => res.json()).catch(() => {
            setLoading(false)
        })

        if (orderData.full) {
            alert("Seats are fully booked.");
            setFull(true);
            return;
        }

        const options = {
            key: process.env.REACT_APP_RAZPAY_KEY,
            amount: orderData.order.amount,
            currency: "INR",
            name: "Heal With Food Workshop",
            description: "Cancer Prevention Program",
            order_id: orderData.order.id,
            prefill: {
                name: values.name,
                email: values.email,
                contact: values.mobile,
            },
            handler: async function (response) {
                const verifyResponse = await fetch(_baseURL + "/camping/verify-payment", {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({
                        ...values,
                        ...response,
                    }),
                }).then(res => res.json()).catch(() => {
                    setLoading(false)
                }).finally(() => {
                    setLoading(false)
                })
                if (verifyResponse.success) {
                    alert("Payment successful! You are registered, and you will receive an email confirmation.");
                    window.location.reload();
                } else {
                    alert("Payment verification failed.");
                }
            },
            modal: {
                ondismiss: function () {
                    // User cancelled payment
                    setLoading(false);
                    console.log("Payment popup closed by user");
                }
            }
        };
        const razor = new window.Razorpay(options);
        razor.open();
    };

    return (
        <div className="container mt-5" style={{ maxWidth: 500, position: 'relative' }}>
            {/* loader */}
            {loading && (
                <div
                    style={{
                        position: "absolute", top: 0, left: 0, width: "100%", height: "100%",
                        background: "rgba(255, 255, 255, 0.7)", display: "flex",
                        justifyContent: "center", alignItems: "center", zIndex: 9999, borderRadius: 8,
                    }}
                >
                    <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
                        <Spinner animation="border" role="status" />
                        <span style={{ fontSize: 18, fontWeight: 500 }}>Please wait...</span>
                    </div>
                </div>
            )}

            <h4 className="text-center">HEAL WITH FOOD : A cancer awareness workshop</h4>
            <p><b>Hosted By & Venue:</b> Yuva Naturecure Hospital, Alwarpet, Chennai</p>
            <p><b>Fee:</b> ₹499</p>
            <p><b>Date:</b> February 21st 2026 </p>
            <p><b>Time:</b> 3pm to 6pm</p>

            {full && (
                <Alert variant="danger">
                    <b>Seats are fully booked!</b>
                </Alert>
            )}

            {!full && (
                <Alert variant="info">
                    Seats available: <b>{available}</b> / {available + count}
                </Alert>
            )}

            {!full && <Formik
                initialValues={{ name: "", email: "", mobile: "" }}
                validationSchema={Yup.object({
                    name: Yup.string().required("Required").max(50, "Maximum 50 characters allowed"),
                    email: Yup.string().email().required("Required").max(70, "Maximum 70 characters allowed"),
                    mobile: Yup.string()
                        .matches(/^[6-9]\d{9}$/, "Enter a valid 10-digit mobile number")
                        .required("Mobile number is required"),
                })}
                onSubmit={handlePayment}
            >
                {({ handleSubmit, handleChange, values, errors, touched }) => (
                    <Form onSubmit={handleSubmit}>

                        <Form.Group className="mb-3">
                            <Form.Label>Name</Form.Label>
                            <Form.Control
                                name="name"
                                onChange={handleChange}
                                value={values.name}
                                isInvalid={touched.name && errors.name}
                                disabled={full}
                            />
                            <Form.Control.Feedback type="invalid">{errors.name}</Form.Control.Feedback>
                        </Form.Group>

                        <Form.Group className="mb-3">
                            <Form.Label>Mobile Number</Form.Label>
                            <Form.Control
                                name="mobile"
                                onChange={handleChange}
                                value={values.mobile}
                                isInvalid={touched.mobile && errors.mobile}
                                disabled={full}
                            />
                            <Form.Control.Feedback type="invalid">{errors.mobile}</Form.Control.Feedback>
                        </Form.Group>

                        <Form.Group className="mb-3">
                            <Form.Label>Email</Form.Label>
                            <Form.Control
                                name="email"
                                onChange={handleChange}
                                value={values.email}
                                isInvalid={touched.email && errors.email}
                                disabled={full}
                            />
                            <Form.Control.Feedback type="invalid">{errors.email}</Form.Control.Feedback>
                        </Form.Group>

                        <Button type="submit" className="w-100" disabled={full}>
                            Pay
                        </Button>
                    </Form>
                )}
            </Formik>}
        </div>
    );
}

export default CampingForm;
